export const QUESTION_STOP_CURRENT_PROGRAMME = 'stop-current-programme';
export const QUESTION_RESTART_CURRENT_PROGRAMME = 'restart-current-programme';
export const QUESTION_START_DATE = 'start-date';
export const CONFIRMATION_MACRO_TARGETS = 'confirmation-macro-targets';
